import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { X } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";

interface IWarningProps {
  closeAlert: () => void;
  color: string;
  icon: ReactNode;
}

export default function Warning({ closeAlert, color, icon }: IWarningProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`text-${color} bg-${color}-light p-2 rounded d-flex justify-content-between align-items-start gap-3 mb-4`}
    >
      <div className="d-flex gap-2 ms-2">
        <div>{icon}</div>
        <div className="col-11 col-md-10">
          {t(
            "payment.You have used almost all free web pages. Сlear unnecessary pages or connect a"
          )}{" "}
          <span className="fw-bold">{t("payment.Premium Plan")}</span>{" "}
          {t("payment.with unlimited page creation.")}
        </div>
      </div>
      <Button variant="" className={`text-${color} p-1`} onClick={closeAlert}>
        <X height={20} width={20} />
      </Button>
    </div>
  );
}
